$(() => {
  $('[warning-button="remove"]').on("click", (e) => {
    var warning = $("#warningElements")[0];
    warning.outerHTML = "";
  });
});
